module.exports = __webpack_public_path__ + "img/mhlogo.9bf6dffe.png";